import {Toast} from "ngx-toastr";
import {Component, ViewEncapsulation} from "@angular/core";

@Component({
    selector: '[app-toastr]',
    templateUrl: './toastr.component.html',
    styleUrls: ['./toastr.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ToastrComponent extends Toast {

}
